import {
  EXCAVATOR_LRU_RS,
  LORRIES_TRANSPORT_RS,
  PLUMS_COST_RS,
} from "../../components/budget/quarrying-excavator/AgGridQuarryingExcavator";
import { _ACTIVITIES } from "../constants";

export const LINKED_QUARRYING_EXCAVATOR_DATA = [
  {
    activity: _ACTIVITIES.LRU,
    theme: [
      { name: PLUMS_COST_RS, quantity: 1 },
      { name: LORRIES_TRANSPORT_RS, quantity: 1 },
      { name: EXCAVATOR_LRU_RS, quantity: 1 },
    ],
  },
];

export const SAVE_CATEGORY_QUARRYING_EXCAVATOR = "quarrying_excavator";

export const LINKED_TURNOVER_LRL_DATA = [
  {
    activity: _ACTIVITIES.LRU,
    theme: [{ name: "Internal Sales - Value", quantity: 1 }],
  },
];

export const SAVE_CATEGORY_TURNOVER_LRL = "turnover_lrl";
